<template>
    <div class="subpage-menu">
        <nav class="subpage-menu__nav" :class="{'open': isDropmenu}">
            <a :href="item.url"
                v-for="(item, index) in module.items" 
                :key="index" 
                class="subpage-menu__item" 
                :class="{'subpage-menu__item--active': item.title === active}">
                {{ item.title }}
            </a>

            <!-- <router-link 
                v-for="(item, index) in module.items" 
                :key="index" 
                :to="{
                    name: item.title,
                    params: { type: item.type.toUpperCase(), id: item._id, slug: getSlug(item.url)},
                }"
                class="subpage-menu__item" 
                :class="{'subpage-menu__item--active': item.title === active}">
                    {{ item.title }}
            </router-link> -->
        </nav>

        <Hamburger :isDropmenu="isDropmenu" :activeColor="activeColor" @click="changeDropmenuState"></Hamburger>
    </div>
</template>

<script>
import Hamburger from "../elements/Hamburger.vue";

export default {
    name: "ModuleSubpageMenu",
    components: {
        Hamburger
    },
    props: {
        module: {
            type: Object,
            required: true,
        },
        active: {
            type: String
        },
        activeColor: {
            type: String
        }
    },
    computed: {
        isDropmenu() {
            return this.$store.getters.isDropmenu;
        }
    },
    methods: {
        changeDropmenuState() {
            this.$store.dispatch("changeDropmenuState");
        },
        getSlug(url) {
            return url.substring(url.lastIndexOf("/") + 1) 
        }
    }
};
</script>